import dayjs            from './day-timezone';
import * as AgencyType  from '../types/Agency';

export const getCurrentVehicleDriverIds = (
    scheduleByDriverId:Record<number,AgencyType.DriverSchedule>,
    vehicleId         : number,
    djs               : dayjs.Dayjs // Should be in correct time zone
) : number[] => {
    const weekdayName = djs.format('dddd').toLowerCase();
    const dayMinutes  = djs.diff(djs.startOf('day'),'minutes');
    return AgencyType.findDriverIds(scheduleByDriverId,(driverId,weekday,range) => {
        // Should return true for any schedule that has this vehicle at the current time
        return ((weekday===weekdayName) && (range[2]===vehicleId) && (dayMinutes>=range[0]) && (dayMinutes<range[1])) ? range : undefined;
    });
}

export const getAgencyCurrentVehicleDriverIds = (
    agency      : AgencyType.Agency,
    vehicleId   : number
) : number[] => {
    return getCurrentVehicleDriverIds(agency.schedule_by_driver_id,vehicleId,dayjs().tz(agency.time_zone));
}

export default getAgencyCurrentVehicleDriverIds;
